import * as React from 'react';

export type LoaderProps = {
  loadingMessage: string;
  height: number;
}

export function Loader(props: LoaderProps) {

  return (<div className="drawer-content flex flex-col justify-center items-center" style={{ height: props.height }}>
      <div className="loader"></div>
      <div className="mt-4 text-xl text-center">
        {props.loadingMessage}
      </div>
  </div>);

}